module.exports = __webpack_public_path__ + "assets/img/e7eb4de73e91bbb2b57f96f2a47ce3c5.svg";